import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import Login from '../views/Login.vue';
import Beer from '../views/Beer.vue';
import Account from '../views/Account.vue';
import Collection from '../views/Collection.vue';
import BeerAdd from '../views/BeerAdd.vue';

Vue.use(VueRouter);

// lazy load seems to give a lot of errors, and it doesn't seem that ussfull for an app

// need to cast to number, vue router turns it into string on history navigation (bug?)
function castCollectionId(route) {
  return {
    collectionId: Number(route.params.collectionId),
  };
}

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: { title: 'Home' },
  },
  {
    path: '/login',
    name: 'Login',
    // component: () => import(/* webpackChunkName: "login" */ '../views/Login.vue'),
    component: Login,
    meta: { title: 'Login' },
  },
  {
    path: '/beer/:beerId',
    name: 'Beer',
    component: Beer,
    props: true,
    meta: { title: 'Beer' },
  },
  {
    path: '/account',
    name: 'Account',
    component: Account,
    props: true,
    meta: { title: 'Account' },
  },
  {
    path: '/collection/:collectionId',
    name: 'Collection',
    component: Collection,
    props: castCollectionId,
    meta: { title: 'Collection' },
  },
  {
    path: '/submit',
    name: 'BeerAdd',
    // component: () => import(/* webpackChunkName: "submit" */ '../views/BeerAdd.vue'),
    component: BeerAdd,
    props: true,
    meta: { title: 'Add Beer' },
  },
  {
    path: '/test',
    name: 'Test',
    component: () => import(/* webpackChunkName: "test" */ '../views/Test.vue'),
    props: true,
  },
];

let HashMode;
if (process.env.CORDOVA_PLATFORM) {
  HashMode = 'hash';
} else {
  HashMode = 'history';
}

const router = new VueRouter({
  mode: HashMode, // history doesn't work with cordova
  base: process.env.BASE_URL,
  routes,
});

// set pagetitle
router.beforeEach((to, from, next) => {
  document.title = 'Beerplanet.net - ' + to.meta.title;
  next();
});

export default router;
